import { render, staticRenderFns } from "./AP.vue?vue&type=template&id=7960aaba"
import script from "./AP.vue?vue&type=script&lang=js"
export * from "./AP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports